<template>
    <van-nav-bar :title="title" style="font-size: 30px;"/>
</template>

<script>
  export default {
    name: "pdaHeader",
    props:['title']
  }
</script>

<style lang="less">

</style>